import styles from './index.module.scss';
import { FC, useState } from 'react';
import Dialog from '@ui/parrot/dialog';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import DialogContent from './dialog';
import { useToggle, useWindowSize } from 'react-use';
import ParrotDrawer from '@ui/parrot/drawer';
import More from './more';

interface OwnProps {
  vault: OpenapiClientParrotVault.GetVaultVaultsResponse['result'][number];
}

const VaultDepositButton: FC<OwnProps> = ({ vault }) => {
  const { width } = useWindowSize();
  const [visible, setVisible] = useState(false);
  const [show, toggleShow] = useToggle(false);

  const onClose = () => {
    setVisible(false);
  };

  return (
    <>
      <div className={styles.button} onClick={() => setVisible(true)}>
        Deposit
      </div>

      {width > 640 ? (
        <Dialog
          isShown={visible}
          width={show ? 448 + 480 : 448}
          title={'Edit profile'}
          onCloseComplete={onClose}
          shouldCloseOnOverlayClick={true}
          hasHeader={true}
          header={<More show={show} toggleShow={toggleShow} />}
        >
          {({ close }) => (
            <DialogContent vault={vault} close={close} show={show} toggleShow={toggleShow} />
          )}
        </Dialog>
      ) : (
        <ParrotDrawer
          onClose={onClose}
          open={visible}
          closable={false}
          height={'85%'}
          maskClosable={true}
        >
          <DialogContent vault={vault} close={onClose} show={show} toggleShow={toggleShow} />
        </ParrotDrawer>
      )}
    </>
  );
};

export default VaultDepositButton;
